import { HttpClientService } from "../service/http-client.service.ts";
import { Observable } from "rxjs";

export class CartRepository {
  protected static getEndpointUrl(): string {
    return "/order";
  }

  static clearCart(): Observable<string> {
    return HttpClientService.post(
      `${this.getEndpointUrl()}/cart/removeAllItems`,
      "",
    );
  }
}
